import { render, staticRenderFns } from "./AlertContainer.vue?vue&type=template&id=22eca492&scoped=true"
import script from "./AlertContainer.vue?vue&type=script&lang=js"
export * from "./AlertContainer.vue?vue&type=script&lang=js"
import style0 from "./AlertContainer.vue?vue&type=style&index=0&id=22eca492&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eca492",
  null
  
)

export default component.exports